import { AppState } from "../../../redux-configuration/AppState";
import { MunicipalService } from "../../domain/entities/municipalService";
import { ServiceIcon } from "../../domain/entities/serviceIcon";

export const listingMunicipalServicesLoadingSelector = (appState: AppState): boolean => appState.municipality.listingServices.loading
export const listingMunicipalServicesErrorSelector = (appState: AppState): string | undefined => appState.municipality.listingServices.error
export const municipalServicesSelector = (appState: AppState): MunicipalService[] | undefined => appState.municipality.listingServices.services
export const serviceIconsSelector = (appState: AppState): ServiceIcon[] | undefined => appState.municipality.listingServices.icons
